import React from 'react'
import { createContext } from 'src/util'
import useHandler from 'src/hooks/useHandler'
import { exportToPng } from 'src/services'

const defaultValue = { ref: {}, generatePng: () => Promise.resolve() }

/**
 * Creates a context for printing svg elements.
 */
export default createContext(
  Provider =>
    function PrintContext(props) {
      // create the ref that will contain the parent node (connected to the resize observer) of the svg element to print
      const ref = React.useRef()

      // add a local state in order to check if png is currently in creation
      const [isPrinting, setPrinting] = React.useState(false)

      // create method to get png
      const generatePng = useHandler(() => {
        setPrinting(true)
        return exportToPng(ref.current).then(png => {
          setPrinting(false)
          return png
        })
      })

      return <Provider {...props} value={{ ref, generatePng, isPrinting }} />
    },
  defaultValue
)
